import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import CisLevel1Rules from "./compliance/CisLevel1Rules";

export const ComplianceBenchmarks = () => {
  const { isLoading } = useQuery({
    queryKey: ["compliance-rules"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("cis_compliance_rules")
        .select("*")
        .order("category", { ascending: true });

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div>Loading compliance rules...</div>;
  }

  return (
    <div className="space-y-4">
      <CisLevel1Rules />
    </div>
  );
};

export default ComplianceBenchmarks;